export const ACCOUNT_DEACTIVATED = "Account deactivated";
export const INVALID_CREDENTIALS = "Invalid credentials";
export const USER_LOGIN_ERRORS = [
  ACCOUNT_DEACTIVATED,
  INVALID_CREDENTIALS,
] as const;
